module.exports = __webpack_public_path__ + "img/Advantage1.7b7e0cea.png";